import type { RuntimeTheme } from './types'
import { normalizeRuntimeTheme } from './normalize'

const THEME_CACHE_KEY = 'emporion.theme.runtime.cache.v1'

export const readCachedRuntimeTheme = (): RuntimeTheme | null => {
  if (typeof window === 'undefined') return null
  try {
    const raw = window.localStorage.getItem(THEME_CACHE_KEY)
    if (!raw) return null
    return normalizeRuntimeTheme(JSON.parse(raw))
  } catch {
    return null
  }
}

export const persistRuntimeTheme = (theme: RuntimeTheme) => {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(THEME_CACHE_KEY, JSON.stringify(theme))
  } catch {
    // no-op (private mode/blocked storage)
  }
}
